import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { findWithUUID } from '@/utils/uuidHelper';
import CreateButton from '@/components/buttons/CreateButton';
import EditButton from '@/components/buttons/EditButton';
import RemoveButton from '@/components/buttons/RemoveButton';
import { deleteActiveLookup, showEditActiveLookup } from '../../dictionaries/actions';

const LookupButtons = ({
  lookups,
  editLookup,
  deleteLookup,
}) => (
  <Button.Group icon compact floated="right" size="small">
    <EditButton entity="lookup" onClick={() => editLookup(false)} disabled={Object.keys(lookups).length === 0} />
    <CreateButton entity="lookup" onClick={() => editLookup(true)} />
    <RemoveButton entity="lookup" disabled={Object.keys(lookups).length === 0} onClick={() => deleteLookup()} />
  </Button.Group>
);

const mapStateToProps = ({
  datasets: {
    lookups,
  },
}) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);

  return (
    {
      lookups: dictionary ? dictionary.lookups || {} : {},
    }
  );
};

const mapDispatchToProps = {
  deleteLookup: deleteActiveLookup,
  editLookup: showEditActiveLookup,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookupButtons);
